{
	"itemsAcrossTopics": "{{topicCount}}个主题中的{{itemCount}}个项目",
	"language": {
		"select": "选择语言",
		"display": "显示语言",
		"english": "英文",
		"chinese": "中文",
		"japanese": "日文",
		"switchedMessage": "语言已从{{from}}切换到{{to}}",
		"currentLanguage": "您当前的语言是{{langname}}",
		"switchLanguage": "切换语言",
		"switchTo": "切换到{{language}}",
		"sectionTitle": "语言"
	},
	"dashboard": {
		"header": {
			"title": "主页",
			"quickStudy": "快速学习"
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "可以更好",
				"itsAwesome": "很棒"
			},
			"title": "你很棒！",
			"body": "很高兴看到您对学习的投入！您对应用程序的体验如何？您愿意分享您的想法并留下评价吗？",
			"cta": "稍后再说"
		},
		"actions": {
			"studyWeak": "练习薄弱领域",
			"viewProgress": "查看进度",
			"seeRank": "查看我的排名",
			"seeRankings": "查看排行榜",
			"unlock": "解锁高级内容",
			"unlockTooltip": "通过解锁高级内容，您将获得独家功能和高级学习材料",
			"startCustomSession": "开始自定义会话",
			"startCustomSessionTooltip": "开始一个自定义会话，专注于您的学习",
			"takeDiagnostic": "进行诊断",
			"takeDiagnosticTooltip": "进行诊断以评估您的当前水平并相应地定制您的学习计划",
			"viewDiagnostic": "查看诊断结果",
			"viewDiagnosticTooltip": "查看您的诊断结果以了解您的优势和需要改进的地方",
			"viewPodcasts": "听播客",
			"viewPodcastsTooltip": "访问教育播客以增强您的学习体验",
			"upgradeToPremium": "升级到高级版",
			"upgradeToPremiumTooltip": "升级到高级版以访问所有内容和功能",
			"extendAccess": "延长访问",
			"extendAccessTooltip": "延长您对高级内容的访问权限",
			"setExamDate": "设置测试日期",
			"setExamDateTooltip": "设置您的测试日期以跟踪您的进度并准备您的测试"
		},
		"stats": {
			"mastery": "掌握度",
			"masteryValue": "{{value}}%",
			"completed": "已完成",
			"completedValue": "{{count}}个项目",
			"xpEarned": "获得",
			"xpEarnedValue": "{{value}} XP",
			"accuracy": "准确率",
			"accuracyValue": "{{value}}%",
			"untilExam": "距离测试",
			"examDate": "测试日期",
			"daysLeft": "{{count}}天",
			"pastDue": "已过期",
			"setExamDate": "设置日期"
		},
		"menu": {
			"store": "商店",
			"settings": "设置"
		},
		"diagnostics": {
			"title": "诊断",
			"free": "免费",
			"Reading & Listening": "阅读 & 听力",
			"Speaking & Writing": "口语 & 写作",
			"duration": "{{count}}个{{item}} • {{minutes}}分钟",
			"completed": "{{count}}个{{item}}已完成",
			"start": "开始",
			"viewReport": "查看报告"
		},
		"skills": {
			"title": "技能",
			"Reading": "阅读",
			"Listening": "听力",
			"Speaking": "口语",
			"Writing": "写作"
		},
		"search": {
			"placeholder": "查找任何内容..."
		}
	},

	"appbar": {
		"home": {
			"title": "主页",
			"subtitle": "您的仪表板"
		},
		"progress": {
			"title": "进度",
			"description": "查看您的表现和需要改进的地方"
		},
		"leaderboard": {
			"title": "排行榜",
			"description": "看看你与其他人相比如何"
		}
	},
	"emptyState": {
		"leaderboard": {
			"title": "还没有领导者",
			"subtitle": "我们仍在收集数据。尝试学习，稍后再回来看看你的表现如何！"
		},
		"progress": {
			"title": "没有学习进度",
			"subtitle": "当你学习时，你的进度会显示在这里",
			"cta": "现在学习"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "错误",
			"body": "会话创建失败，请重试"
		}
	},
	"mastery": {
		"labels": {
			"high": "已掌握",
			"medium": "接近掌握",
			"low": "需要练习",
			"none": "未回答",
			"advanced": "高级",
			"intermediate": "中级",
			"basic": "基础"
		}
	},
	"leaderboard": {
		"you": "这是你",
		"resetIn": "排行榜将在{{days}}天后重置",
		"periods": {
			"all_time": "所有时间",
			"month": "本月",
			"week": "本周"
		},
		"scope": {
			"global": "全球",
			"friends": "好友"
		},
		"friends": {
			"soon": "即将上线",
			"comingSoonTitle": "好友排行榜",
			"comingSoonBadge": "即将推出",
			"comingSoonDescription": "与好友比拼进度，看看谁能登顶排行榜。"
		},
		"error": {
			"title": "连接错误",
			"description": "无法加载排行榜。请检查网络连接后重试。",
			"tryAgain": "重试"
		},
		"empty": {
			"title": "暂无排名",
			"description": "快来学习，抢占排行榜榜首。",
			"startLearning": "开始学习"
		},
		"topPerformers": "表现最佳",
		"yourPosition": "你的排名",
		"rankings": "排名",
		"rankingsRange": "排名 • 第{{startRank}}–{{endRank}}名",
		"unranked": {
			"title": "赚取经验值进入排名！",
			"description": "开始一次学习会话，获得首次积分并登上排行榜。",
			"cta": "开始第一次会话"
		},
		"xpAmount": "<num>{{value}}</num> <unit>经验</unit>",
		"youBadge": "你",
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit>经验</unit> <rest>即可超过第{{rank}}名</rest>",
			"gapHintFromPodium": "<num>+{{value}}</num><unit>经验</unit> <rest>距领奖台</rest>"
		}
	},
	"sessionConfig": {
		"title": "自定义学习课程",
		"diagnostic": "诊断",
		"skill": "技能",
		"mastery": "掌握程度",
		"setCount": "{{count}} {{type}}",
		"dismiss": "确定",
		"status": {
			"notAnswered": "未回答",
			"needsWork": "需要练习"
		},
		"itemCount": "您将完成{{topics}}个主题的{{count}}个题目",
		"start": "开始",
		"configuringSession": "正在配置会话...",
		"fetchingContent": "正在获取内容...",
		"preparingMaterials": "正在准备材料...",
		"almostThere": "即将完成...",
		"startingSession": "正在开始会话...",
		"playIcon": "play-outline",
		"infoText": "您将完成**{{numItems}}**个{{itemCount}}。这将花费大约**{{timeString}}**。"
	},
	"learningModes": {
		"questions": "题目",
		"reading": "阅读",
		"listening": "听力",
		"writing": "写作",
		"speaking": "口语",
		"readingListening": "阅读和听力",
		"speakingWriting": "口语和写作"
	},
	"progress": {
		"tagProgress": {
			"subtitle": "基于{{numItems}}个{{item}}尝试，跨越{{count}}个{{type}}",
			"itemCount": "{{count}}个{{item}}",
			"tooltip": "这显示了你在{{count}}个{{type}}中的进度。它基于你目前尝试的{{itemCount}}个{{item}}。"
		},
		"itemTypeProgress": {
			"title": "项目类型表现",
			"subtitle": "基于{{count}}个{{item}}",
			"tooltip": "这显示了你在{{count}}个{{type}}中的表现"
		},
		"needsImprovement": {
			"title": "需要改进",
			"subtitle": "推荐{{type}}以提高",
			"cta": "开始学习"
		},
		"mastery": {
			"high": "已掌握",
			"medium": "接近掌握",
			"low": "需要练习",
			"count": "{{count}}个{{item}}尝试",
			"highTooltip": "你已掌握{{count}}个{{item}}",
			"mediumTooltip": "你正在进步，已完成{{count}}个{{item}}",
			"lowTooltip": "你需要更多练习，还有{{count}}个{{item}}"
		},
		"stats": {
			"completion": "完成度",
			"completionCount": "{{completed}}/{{total}}个{{item}}",
			"completionTooltip": "你已完成{{total}}个{{item}}中的{{completed}}个"
		},
		"summary": {
			"title": "学习概要",
			"subtitle": "基于{{count}}个{{item}}尝试",
			"mastery": "掌握度",
			"quickStats": "快速统计",
			"tooltip": "这个总结显示了你在{{count}}个{{item}}中的掌握度和完成进度。你的表现是通过练习、评估和学习活动来衡量的。"
		},
		"practiceTests": {
			"performanceTooltip": "你的预计表现为{{score}}%",
			"estimatedPerformance": "预计表现"
		}
	},
	"premium": {
		"chip": "高级版",
		"tooltip": "高级内容",
		"upgrade": "升级到高级版"
	},
	"purchase": {
		"checkout": {
			"headerTitle": "完成您的购买"
		},
		"studyPackDialogTitle": "升级您的学习计划",
		"practiceTestDialogTitle": "解锁模拟测试",
		"defaultDialogTitle": "升级您的学习计划",
		"paywall": {
			"title": "解锁所有项目，最大化您的测试准备 {{date}}",
			"beforeDate": "{{date}}之前",
			"accessHere": "访问这里",
			"recommendedPlan": "我们推荐**{{duration}}{{interval}}**计划，以最佳准备您的测试{{dateText}}",
			"purchaseDisclaimer": "确认购买后，您将在所选期限内获得此产品内容的完全访问权。当此期限到期时，您将失去对受限内容的访问权。如果您因任何原因希望延长访问时间（例如，您更改了考试日期），可以通过额外的应用内购买来添加时间。更多信息，请参阅我们的[服务条款和隐私政策]({{tosLink}})。",
			"accesDuration": {
				"yearPlan": "**{{duration}}{{interval}}**计划提供延长访问权限，让您可以灵活地按照自己的节奏学习，并全面准备测试。",
				"moreTime": "如果您认为需要更多时间学习，可以考虑**{{yearPlanDuration}}{{yearPlanInterval}}**计划。",
				"otherPlan": "**{{duration}}{{interval}}**计划将授予您访问权限直到**{{expiryText}}**，这给您足够的时间学习。{{moreTime}}"
			}
		},
		"success": {
			"headerTitle": "感谢您的购买！",
			"subtitle": "您的购买已成功",
			"accessGranted": "您已成功获得{{name}}的访问权限",
			"purchaseSuccessful": "您的{{name}}购买成功",
			"studyPack": "学习包",
			"practiceTest": "模拟测试",
			"combo": "组合",
			"documentTitle": "购买"
		}
	},
	"auth": {
		"incorrectPasscode": "错误的验证码",
		"verify": {
			"openEmail": "打开邮箱以继续",
			"signInCta": "验证您的账户...",
			"signUpCta": "创建您的账户...",
			"contactSupport": "没有收到邮件？请检查垃圾邮件文件夹或",
			"contactSupportLink": "联系我们",
			"resendMagicLink": "重发魔法链接",
			"resendMagicLinkIn": "{{time}}后可重发魔法链接",
			"signInBody": "您快完成了！验证您的详细信息以安全登录到{{appName}}应用。",
			"signUpBody": "您快完成了！验证您的详细信息以创建您的{{appName}}应用账户。",
			"magicLinkEmail": "我们已发送一个魔法链接至**{{email}}**\n点击邮箱中的链接以安全登录。",
			"magicLinkEmailExpiry": "此链接将在10分钟后过期",
			"confirmEmail": "确认您的邮箱",
			"redirectingToApp": "重定向到{{appName}}应用...",
			"appNotOpen": "应用未打开？点击下方按钮以打开关联的应用",
			"openApp": "打开{{appName}}应用",
			"installAppPrompt": "如果没有任何反应，请确保您已在设备上安装{{appName}}应用",
			"verifyAccountTitle": "验证您的账户",
			"emailResent": "我们已发送邮件，请查看您的邮箱，包括垃圾邮件或垃圾邮件文件夹",
			"verificationLinkExpired": "验证链接已过期",
			"verificationLinkExpiredBody": "验证链接在10分钟后过期，且只能使用一次。您可以再次登录以请求新的链接",
			"loginAgain": "再次登录",
			"contactSupportExpiredLink": "如果此问题继续存在，请告诉我们"
		}
	},
	"account": {
		"title": "账户设置",
		"subtitle": "管理您的账户设置",
		"currentExam": "当前测试",
		"examDate": "测试日期",
		"selectDate": "选择日期",
		"appearance": "外观",
		"features": "功能",
		"audioPlaybackTest": "显示测试音频播放对话框",
		"darkMode": "深色模式",
		"accountInfo": "账户",
		"name": "姓名",
		"email": "电子邮箱",
		"dev": "开发",
		"sandbox": "沙盒",
		"about": "关于",
		"termsOfService": "服务条款",
		"privacyPolicy": "隐私政策",
		"support": "支持",
		"supportEmailBody": "我因以下问题需要您的帮助：[  ]\n\n\n\n以下是有助于更快解决问题的有用信息：\n\n与账户关联的用户名（在登录应用后在设置中可以找到）：\n{{username}}\n\n与订单关联的邮箱（在登录应用后在设置中可以找到）：\n{{email}}\n\n订单号（通常在购买时触发的收据邮件中可以找到）：\n\n购买产品时是否可能使用了不同的姓名或邮箱？如果是，请提供：\n\n姓名：\n\n邮箱：",
		"contactSupport": "联系支持",
		"signOut": "退出登录",
		"signOutConfirmation": "您确定要退出登录吗？",
		"deleteAccount": "删除账户",
		"platform": "平台",
		"partnerships": "合作伙伴",
		"validUntil": "有效期至{{date}}",
		"extendValidity": "延长访问",
		"frequentlyAskedQuestions": "常见问题"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "您喜欢什么？有什么可以改进的？我们每天都在改进平台，我们的团队阅读每一条反馈。谢谢！",
			"title": "分享您的反馈",
			"body": "您喜欢什么？有什么可以改进的？我们每天都在改进平台，我们的团队阅读每一条反馈。**谢谢！**",
			"positiveBody": "很高兴这对您有帮助！请告诉我们**您喜欢什么。**",
			"negativeBody": "帮助我们了解哪里出了问题，以便我们**改进回答。**",
			"placeholder": "输入反馈",
			"cta": "发送反馈"
		},
		"report": {
			"title": "提交报告",
			"body": "帮助我们了解这个回答有什么问题",
			"cta": "提交报告"
		},
		"suggestCorrection": {
			"title": "建议修正",
			"body": "帮助我们提高此内容的准确性，请**报告任何错误。**",
			"cta": "提交"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "不准确",
					"description": "回答包含不正确的信息"
				},
				"notHelpful": {
					"title": "没有帮助",
					"description": "回答没有解决我的问题"
				},
				"incomplete": {
					"title": "不完整",
					"description": "回答缺少重要的细节"
				},
				"hardToUnderstand": {
					"title": "难以理解",
					"description": "回答令人困惑或不清楚"
				},
				"other": {
					"title": "其他",
					"description": "其他原因"
				}
			},
			"report": {
				"misinformation": {
					"title": "虚假信息",
					"description": "回答包含虚假或误导性信息"
				},
				"harmfulContent": {
					"title": "有害或冒犯性内容",
					"description": "仇恨言论、骚扰或不当语言"
				},
				"violatesPolicies": {
					"title": "违反政策",
					"description": "垃圾信息、自我推广或非法内容"
				},
				"other": {
					"title": "其他",
					"description": "用您自己的话描述问题所在"
				}
			}
		},
		"faqs": {
			"title": "常见问题解答",
			"body": "这里有一些关于应用的常见问题。如果您有任何其他问题，请随时联系我们support@memorang.ai"
		},
		"delete": {
			"title": "删除账户",
			"placeholder": "反馈",
			"chooseReason": "选择原因",
			"body": "我们很遗憾看到您离开，祝您在学业和职业道路上一切顺利！",
			"options": "太贵了|已经参加了测试|不喜欢内容|缺少功能/功能性|其他",
			"confirmdelete": {
				"title": "确认删除账户",
				"cta": "删除",
				"errorMessage": "抱歉，该邮箱与该账户不匹配。请重试",
				"successMessage": "账户删除成功！",
				"validEmail": "请输入有效的邮箱地址"
			}
		},
		"notifyAppLaunch": {
			"title": "加入移动应用等待名单",
			"body": "{{appName}}移动应用即将在iPhone和Android上推出。**可能不是所有地区都会同时上线。**点击下方按钮，在您所在地区上线时第一时间收到通知。",
			"cta": "加入等待名单",
			"successMessage": "您已加入等待名单！我们将在{{appName}}移动应用上线时通知您。",
			"failedMessage": "无法加入等待名单。请稍后再试。"
		}
	},
	"common": {
		"activity": "练习",
		"this": "这个",
		"unlock": "解锁",
		"itemCount": "{{count}}个项目",
		"item": "项目",
		"knowMore": "了解更多",
		"attempt": "尝试",
		"proficiency": "掌握度",
		"items": "项目",
		"of": "之",
		"didNotAnswer": "您尚未尝试的项目",
		"notAnswered": "未回答",
		"attempted": "尝试",
		"points": "分",
		"eg": "例如",
		"performance": "表现",
		"details": "详情",
		"estimatedProficiency": "预计掌握度",
		"keepPracticing": "继续练习——你做得很好！",
		"set": "组",
		"selectTestDate": "选择测试日期",
		"copiedToClipboard": "已复制到剪贴板",
		"leaveFeedback": "留下反馈",
		"hint": "提示",
		"itemType": "项目类型",
		"minute": "分钟",
		"minutes": "分钟",
		"hour": "小时",
		"hours": "小时",
		"continue": "继续",
		"cancel": "取消",
		"ok": "确定",
		"yes": "是",
		"free": "免费",
		"correct": "正确",
		"incorrect": "错误",
		"sec": "秒",
		"marked": "已标记",
		"skipped": "已跳过",
		"skill": "技能",
		"word": "字",
		"submitResponse": "提交回答",
		"viewDetails": "查看详情",
		"week": "周",
		"month": "月",
		"year": "年",
		"on": "在",
		"day": "天",
		"and": "和"
	},
	"session": {
		"attributes": {
			"stimulus": "刺激"
		},
		"stimulusTypes": {
			"reading": "阅读",
			"listening": "听力",
			"speaking": "口语",
			"writing": "写作"
		},
		"itemTypes": {
			"MCSS": "单选题",
			"MCSSH": "单选高亮题",
			"MCMS": "多选题",
			"MCMSH": "多选高亮题",
			"INSERT_TEXT": "插入文本题",
			"MATCH_MS": "多项匹配题",
			"MCSSM": "单选匹配题",
			"MCMSM": "多选匹配题",
			"MCGS": "填空选择题",
			"MCOS": "排序选择题",
			"LISTENING_REPLAY": "听力重放题",
			"AUDIO_INPUT": "音频输入题",
			"ACADEMIC_DISCUSSION_RESPONSE": "学术讨论回应题",
			"INTEGRATED_WRITING_RESPONSE": "综合写作回应题"
		},
		"masteryLevels": {
			"basic": "基础",
			"belowBasic": "低于基础",
			"lowIntermediate": "低中级",
			"belowLowIntermediate": "低于低中级",
			"highIntermediate": "高中级",
			"advanced": "高级",
			"proficiencySubtitle": "在{{trademark}}中，这对应于**{{minScore}}-{{maxScore}}/30**的分数",
			"infoSectionLabel": "{{skill}} 部分信息",
			"infoSectionText": {
				"Reading": "{{trademark}} 阅读部分评估您阅读和理解学术材料的能力。它包括两篇阅读材料，每篇约700字，包含10道题目。完成阅读部分大约需要35分钟。",
				"Listening": "{{trademark}} 听力部分旨在测量您理解口语和讲座的能力。它包括听力材料，包括基本理解、理解说话者的态度和确定性以及连接信息。完成听力部分大约需要36分钟。",
				"Speaking": "{{trademark}} 口语部分测量您在学术环境中有效使用英语的能力。四个问题/任务类似于您可能在学校内外遇到的现实生活情况。完成口语部分大约需要16分钟。",
				"Writing": "{{trademark}} 写作部分测量您在学术环境中使用英语的能力。您将在计算机上输入您的回答，完成写作部分大约需要29分钟。"
			}
		},
		"passageStem": {
			"item": "项目",
			"of": "之",
			"passage": "段落",
			"lecture": "讲座",
			"professorsQuestion": "教授的问题",
			"listen": "听",
			"openPassage": "打开段落",
			"notYetInserted": "尚未插入",
			"insertedAtPosition": "插入位置 #{{position}}"
		},
		"hint": {
			"show": "显示提示"
		},
		"navigation": {
			"next": "下一个",
			"previous": "上一个",
			"skip": "跳过",
			"finish": "完成",
			"help": "帮助",
			"questionsButtonLabel": "问题",
			"questionsButtonTooltip": "跳转到任何问题并查看回答、跳过和标记的项目。",
			"questionsButtonActiveFiltersA11y": "已选筛选：{{count}} 个"
		},
		"stats": {
			"skill": "技能",
			"answered": "已回答",
			"speed": "速度",
			"response": "回应",
			"confidence": "信心",
			"pointsEarned": "获得积分",
			"word": "字",
			"words": "字数",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "您花了 {{time_taken}} 秒阅读和回答这个问题{{end}}",
			"time_taken_tooltip_end": "，包括这个 {{stimulus_type}} 刺激"
		},
		"explanation": {
			"title": "解释",
			"feedback": "反馈"
		},
		"followUps": "后续问题",
		"suggestCorrection": "建议修正",
		"answer": {
			"correct": "正确",
			"incorrect": "错误",
			"skipped": "已跳过"
		},
		"confidence": {
			"high": "高",
			"medium": "中",
			"low": "低"
		},
		"endDialog": {
			"title": "提前结束学习会话？",
			"confirmEndDiagnostic": "您确定要结束本次会话吗？所有进度将丢失，您需要重新开始。",
			"confirmEnd": "您还有 {{num}} {{itemLabel}} 未完成。您可以现在结束，也可以继续学习完成它们。",
			"confirmEndNoAnswer": "您还没有回答任何问题。您确定现在要结束吗？",
			"confirmEndNoAnswerPositive": "继续学习",
			"confirmEndNoAnswerNegative": "现在结束"
		},
		"permissionDialog": {
			"title": "允许麦克风",
			"descriptionWeb": "要录制您的声音，我们需要访问麦克风。单击地址栏左侧的图标，并启用麦克风权限。",
			"descriptionMobile": "要录制您的声音，我们需要使用您的麦克风。请在您的设备设置中启用麦克风权限。",
			"ok": "好的",
			"cancel": "取消",
			"openSettings": "打开设置"
		},
		"audioPlaybackTestDialog": {
			"title": "测试音频播放",
			"description": "{{appName}} 包含多个音频播放功能，例如刺激、测试项目和文本转语音。为了确保最佳体验，请测试您的音频。一旦确认正常，请继续。",
			"troubleshooting": {
				"title": "音频问题故障排除",
				"volumeTitle": "检查设备音量",
				"volumeDescriptionWeb": "使用键盘控制或菜单/任务栏中的系统音量设置调节音量",
				"volumeDescriptionMobile": "使用设备音量按钮或在系统设置中调节",
				"outputTitle": "验证音频输出设备",
				"outputDescription": "如果使用耳机，请确保它们正确连接并被选为活动输出设备",
				"browserTitle": "检查浏览器标签页音频",
				"browserDescription": "查看标签页标题旁边是否有静音扬声器图标，如果有则取消静音"
			},
			"skipCheck": "下次跳过此检查",
			"workingButton": "确认音频正常",
			"textToHear": "你应该听到：{{text}}"
		},
		"overall": "总体",
		"feedback": {
			"greatJob": "干得好！",
			"niceWork": "不错的工作！",
			"wellDone": "做得好！",
			"excellent": "优秀！",
			"outstanding": "出色！",
			"fantastic": "太棒了！",
			"brilliant": "精彩！",
			"amazingWork": "令人惊叹的工作！",
			"superb": "卓越！",
			"wayToGo": "继续加油！",
			"perfect": "完美！",
			"impressive": "令人印象深刻！",
			"stellarWork": "出色的工作！",
			"awesomeJob": "了不起的工作！",
			"excellentEffort": "出色的努力！",
			"remarkable": "非凡！",
			"youNailedIt": "你做到了！",
			"terrificWork": "了不起的工作！",
			"negative": {
				"hangIn": "坚持住",
				"youCanDoIt": "你可以的",
				"keepTrying": "继续尝试，你会成功的",
				"persistenceKey": "坚持是关键",
				"practiceMakesPerfect": "熟能生巧",
				"keepGoingStrong": "继续加油"
			}
		},
		"subskills": {
			"content": {
				"title": "内容",
				"integratedWriting": "您的回答应准确呈现讲座中的要点，并将其与阅读材料联系起来。避免重大遗漏、不准确或对任何一个来源的观点进行错误表述。",
				"academicDiscussionWriting": "您的回答应直接回应教授的问题或课堂讨论主题。提供相关的观点或意见，并通过示例、个人经历或逻辑推理来支持。保持话题相关性，为讨论做出有意义的贡献。",
				"integratedSpeaking": "准确总结或综合听力材料（如包含阅读材料）中的要点。明确建立材料之间的联系（例如，讲座如何反驳或支持阅读材料）。避免重大遗漏或对内容的错误表述。",
				"independentSpeaking": "通过陈述清晰的个人观点或选择来充分回应提示，并提供充分的理由和例子作为支持。保持内容相关性和重点，确保您的回答与问题直接相关。"
			},
			"languageUse": {
				"title": "语言运用",
				"integratedWriting": "您的回答应使用准确的语法、恰当的词汇和清晰的句子结构。只要不影响意思表达或打断流畅度，小错误是可以接受的。",
				"academicDiscussionWriting": "展示清晰简洁的写作，使用适合课堂论坛的学术语言。基本语法和句子结构应正确，错误应保持在最小程度，不影响清晰度。选用能准确传达观点的词汇，同时保持讨论环境中的自然语气。",
				"integratedSpeaking": "使用语法准确的句子和词汇来传达必要信息。小失误是可以接受的，但不应造成混淆或频繁重述。展示足够的结构和词汇掌握能力，以有效表达来源材料中各观点之间的关系。",
				"independentSpeaking": "准确运用词汇和语法来表达您的想法。虽然小错误是可以接受的，但不应显著影响回答的流畅度或清晰度。努力使用多样的句子结构来支持连贯流畅的表达。"
			},
			"organizationAndDevelopment": {
				"title": "组织与发展",
				"integratedWriting": "您的回答应组织良好，包含清晰的引言、正文和结论。使用逻辑过渡并充分展开观点以有效支持您的论点。",
				"academicDiscussionWriting": "撰写简短但连贯的回答，构建语句使每个观点都建立在前一个观点之上。即使在简短的帖子中，也要包含简明的引言（陈述立场）、正文（用理由或例子支持）和简洁的结论或总结。在观点之间建立逻辑联系，使同学们能轻松理解您的论点。"
			},
			"topicDevelopment": {
				"title": "主题发展",
				"integratedSpeaking": "准确总结或综合听力材料（如包含阅读材料）中的要点。明确建立材料之间的联系（例如，讲座如何反驳或支持阅读材料）。避免重大遗漏或对内容的错误表述。",
				"independentSpeaking": "通过陈述清晰的个人观点或选择来充分回应提示，并提供充分的理由和例子作为支持。保持内容相关性和重点，确保您的回答与问题直接相关。"
			},
			"delivery": {
				"title": "表达",
				"integratedSpeaking": "以清晰、自然的语速说话，保持正确的发音和语调。偶尔的停顿、轻微的发音错误或小的语速问题是可以接受的，但不应影响整体理解。您的回答应该让听众容易理解。",
				"independentSpeaking": "自然地说话，保持适当的音量和语速。发音和语调应足够清晰，让听众能轻松理解您的表达。偶尔的小错误或犹豫不应影响理解。"
			}
		},
		"aiStates": {
			"processingAudio": "正在处理音频...",
			"analyzingSpeech": "正在分析您的语音...",
			"gradingResponse": "正在评分您的回答...",
			"generatingFeedback": "正在生成反馈...",
			"processingText": "正在处理文本..."
		}
	},
	"feedback": {
		"successMessage": "感谢您的反馈！"
	},
	"report": {
		"pointsInfo": {
			"feedbackText": {
				"advanced": "出色的表现——继续追求卓越！",
				"highIntermediate": "你做得很棒——继续磨练你的优势！",
				"lowIntermediate": "你的进步很稳定——继续保持！",
				"basic": "继续努力提升你的能力！"
			},
			"infoText": "您完成了 **{{numActivities}} {{activityLabel}}** 来练习您的 {{skillsText}} {{skills}}. {{skillDetails}}. 总体上，您获得了 **{{numPointsEarned}} 分**，表明您在 {{thisText}} {{skills}} 上的 **{{compositeLevel}} 水平**。{{compositeFeedback}}",
			"infoText.singleSkill": "您完成了 **{{itemCount}} {{itemLabel}}**，专注于您的 **{{skill_1}}** 技能。您获得了 **{{skill_1_score}} 分（总分 {{skill_1_total}} 分）**，表明您达到了 **{{proficiency}}** 水平。{{compositeFeedback}}",
			"infoText.multiSkill": "您完成了 **{{itemCount}} {{itemLabel}}**，练习了您的 **{{skills_text}}** 技能。{{skill_details}} 总体上，您获得了 **{{overall_score}} 分（总分 {{overall_total}} 分）**，表明您在这些技能上达到了 **{{overall_proficiency}}** 水平。{{compositeFeedback}}",
			"skillDetails": "在 **{{skill}}** 中，您获得了 **{{score}} 分（总分 {{total}} 分）**，表明 **{{proficiency}}** 水平。"
		},
		"productName": "{{examName}} {{type}}",
		"practiceTests": "模拟测试",
		"studyPack": "学习包",
		"diagnosticCompleted": "断评估完成",
		"practiceTestCompleted": "模拟测试完成",
		"studySessionCompleted": "学习课程完成",
		"diagnosticSessionCompleted": "诊断评估完成",
		"answered": "已回答",
		"answeredTooltip": "您回答的问题数量",
		"correct": "正确",
		"correctTooltip": "您正确回答的问题数量",
		"accuracy": "准确率",
		"accuracyTooltip": "您正确回答问题的百分比",
		"duration": "持续时间",
		"durationTooltip": "您完成测试所用的时间",
		"timeElapsed": "已用时间",
		"timeElapsedValue": "{{time}} {{sec}}",
		"timeElapsedTooltip": "您完成测试所用的时间",
		"avgSpeed": "平均速度",
		"avgSpeedValue": "{{speed}} {{sec}}",
		"avgSpeedTooltip": "您回答每个问题所用的时间",
		"hintsUsed": "使用的提示",
		"hintsUsedTooltip": "本次课程中使用的提示数量",
		"pointsEarned": "获得的积分",
		"pointsEarnedDescription": "您已获得 {{numPointsEarned}} 分，总分 {{numTotalPoints}} 分",
		"stats": {
			"answered": "已回答",
			"time elapsed": "已用时间",
			"avg speed": "平均速度",
			"hints used": "使用的提示"
		},
		"actions": {
			"studyMore": "继续学习",
			"reviewAnswers": "复习答案"
		},
		"performance": {
			"title": "表现",
			"subtitle": "基于 {{count}} 个项目",
			"correct": "正确",
			"correctItems": "{{count}} 个项",
			"incorrect": "错误",
			"incorrectItems": "{{count}} 个项目"
		},
		"mastery": {
			"performanceTitle": "表现",
			"sessionMasteryTitle": "估计掌握度",
			"subtitle": "基于 {{count}} 个{{item}} 在本课程中",
			"correct": "正确",
			"incorrect": "错误",
			"marked": "已标记",
			"skipped": "已跳过"
		},
		"sessionAnalysis": {
			"title": "会话分析",
			"subtitle": "个性化分析和建议",
			"viewFullAnalysis": "查看完整分析",
			"menuActions": {
				"copy": "复制",
				"altCopy": "复制摘要文本",
				"altPositiveFeedback": "这很有帮助",
				"altNegativeFeedback": "这可以更好",
				"positiveFeedback": "好的回答",
				"negativeFeedback": "不好的回答",
				"reportIssue": "举报",
				"altReportIssue": "举报此回答",
				"emailSummary": "发送摘要",
				"emailAlreadySent": "已发送",
				"copiedAnalysis": "已复制分析到剪贴板",
				"emailSent": "已发送至 {{email}}，如果您没有收到电子邮件，请检查垃圾邮件、垃圾邮件和最近删除的文件夹，或联系您的IT管理员",
				"emailFailed": "发送失败至 {{email}}",
				"emailInstructionMessage": "如果您没有收到电子邮件，请检查垃圾邮件、垃圾邮件和最近删除的文件夹，或联系您的IT管理员"
			},
			"feedbackDialog": {
				"title": "帮助我们改进",
				"body": "我们几乎每天都在改进，我们决心改进。您愿意**留下反馈**吗？",
				"placeholder": "输入您的反馈",
				"cta": "发送反馈",
				"successMessage": "感谢您的反馈！",
				"feedbackLimitError": "反馈必须至少10个字符"
			}
		}
	},
	"encouragements": {
		"positive": {
			"great": "你做得很棒！",
			"wellDone": "做得好！",
			"impressive": "令人印象深刻！",
			"amazing": "你太厉害了！",
			"awesome": "你真棒！",
			"onARoll": "你势如破竹！",
			"quitePerformance": "表现非凡！",
			"fantasticEffort": "努力出色！",
			"keepItUp": "继续保持！",
			"knowledgeCourses": "知识如泉涌！"
		},
		"negative": {
			"hangIn": "坚持住",
			"youCanDoIt": "你可以的",
			"keepTrying": "继续尝试，你会成功的",
			"improvementSteps": "进步是一步一步来的",
			"learnFromWrong": "错误也是学习的机会",
			"persistenceKey": "坚持是关键",
			"practiceMakesPerfect": "熟能生巧",
			"keepGoingStrong": "继续加油"
		}
	},
	"aila": {
		"askYourOwnQuestion": "问您自己的问题"
	},
	"recorder": {
		"alert": {
			"title": "最大时长已达到",
			"body": "录音已停止，因为它已达到最大时长{{maxDuration}}秒。"
		},
		"tapToRecord": "点击按钮开始录音",
		"uiElementPressed": "录音停止 - 在录音过程中打开刺激。"
	},
	"writing": {
		"placeholder": "在此处写下您的回答...",
		"wordCount": "{{count}} {{word}}",
		"title": "您的回答",
		"submit": "提交"
	},
	"navbar": {
		"home": "主页",
		"progress": "进度",
		"leaderboard": "领先者",
		"store": "商店",
		"more": "更多",
		"redeem": "兑换",
		"podcasts": "播客",
		"study-pack": "学习包"
	},
	"tts": {
		"tooltip": "听这段文字"
	},
	"commandBar": {
		"placeholder": "搜索任何内容...",
		"accessibilityLabel": "命令栏",
		"accessibilityHint": "激活以搜索或使用命令",
		"actions": {
			"home": "去主页",
			"progress": "去进度",
			"changeTheme": "更改主题",
			"leaderboard": "去排行榜",
			"settings": "去设置",
			"premium": "升级到高级版",
			"setExamDate": "设置测试日期",
			"startSession": "开始学习"
		}
	},
	"noInternetAccess": {
		"title": "没有互联网访问",
		"subtitle": "访问互联网是使用此应用程序所必需的。请检查您的WiFi和数据设置",
		"retry": "重试",
		"connectionRestored": "连接已恢复！您已恢复在线"
	},
	"onboarding": {
		"steps": {
			"welcome": {
				"title": "欢迎使用TOEFL Practice！",
				"description": "TOEFL iBT官方AI教练",
				"cta": "开始使用",
				"bottomLabelMobile": "让我们为您量身定制学习计划，并展示如何有效使用您的AI教练"
			},
			"goal": {
				"title": "您的目标是什么？",
				"description": "选择最符合您TOEFL iBT目标的描述",
				"cta": "继续"
			},
			"testDate": {
				"title": "设置考试日期",
				"description": "我们将根据您已知或预计的考试日期发送提醒并定制您的学习计划",
				"cta": "继续",
				"bottomLabel": "您可以随时更改此设置。"
			},
			"skills": {
				"title": "工作原理",
				"description": "TOEFL iBT考察四项核心技能：阅读、听力、口语和写作",
				"cta": "开始",
				"bottomLabel": "快速体验演示，了解如何使用应用程序的核心功能"
			},
			"features": {
				"title": "准备就绪！",
				"description": "以下是您学到的内容：",
				"descriptionMobile": "以下是您可以做的：",
				"cta": "开始诊断测试",
				"secondaryCta": "返回首页",
				"bottomLabel": "浏览应用或立即开始免费诊断测试"
			}
		},
		"goals": {
			"firstTime": {
				"label": "首次考试",
				"description": "我是第一次参加考试"
			},
			"retaking": {
				"label": "重考",
				"description": "我正在重考以提高分数"
			},
			"exploring": {
				"label": "探索了解",
				"description": "我想更熟悉考试并评估我的准备程度"
			}
		},
		"actions": {
			"skip": "跳过"
		},
		"features": {
			"confidence": {
				"label": "设置信心度以跟踪进度",
				"description": "这将帮助应用程序从您那里学习并提供更个性化的体验"
			},
			"verified": {
				"label": "提交答案获取反馈",
				"description": "TOEFL AI将根据您的具体回答生成个性化反馈"
			},
			"assistant": {
				"label": "询问AI学习助手",
				"description": "深入了解每个项目并学习如何提高技能"
			}
		},
		"skills": {
			"reading": "阅读",
			"listening": "听力",
			"speaking": "口语",
			"writing": "写作"
		}
	}
}
